import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {SenatorQualityGateService, SenatorService} from '../../../../../api/services';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SenatorCompany} from '../../../../../api/models/senator-company';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ShowTradeByIdComponent} from '../show-trade-by-id/show-trade-by-id.component';
import {SenatorAssetType} from '../../../../../api/models/senator-asset-type';
import {SenatorIssuerMappingsFilterModel} from '../../../../../api/models/senator-issuer-mappings-filter-model';
import {SenatorQualityGateType} from '../../../../../api/models/senator-quality-gate-type';
import {SenatorQualityGateModel} from '../../../../../api/models/senator-quality-gate-model';
import GetReplaceableAssetNamesParams = SenatorQualityGateService.GetReplaceableAssetNamesParams;
import {SenatorIssuerSecurityTypeReviewRow} from '../../../../../api/models/senator-issuer-security-type-review-row';
import {AssetTypeStat} from '../../../../../api/models/asset-type-stat';
import {SelectionModel} from '@angular/cdk/collections';
import {SenatorIssuerSecurityTypeUpdate} from '../../../../../api/models/senator-issuer-security-type-update';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SenatorAmountRanges} from '../../../../../api/models/senator-amount-ranges';


@Component({
  selector: 'app-issuer-trade-security-types-review',
  templateUrl: './issuer-trade-security-types-review.component.html',
  styleUrls: ['./issuer-trade-security-types-review.component.scss']
})
export class IssuerTradeSecurityTypesReviewComponent implements OnInit, AfterViewInit {

  twoIQAssetsList: SenatorCompany[] = [];
  @ViewChild(MatTable) table: MatTable<any>;

  @ViewChild(ShowTradeByIdComponent)
  showTradeById: ShowTradeByIdComponent;

  // mat table vars
  displayedColumns: string[] = ['select', 'transactionDate', 'source', 'nameBotGrabbed', 'x2iqAssetClass',
    'transactionType', 'price', 'ourComments', 'actions'];

  multipleSelectionHeader = ['msCheck', 'msTransactionDate', 'msSource', 'msNameBotGrabbed', 'msX2iqAssetClass', 'msTransactionType', 'msPrice',
    'msOurComments', 'msActions',];

  issuerTableDataSource: MatTableDataSource<SenatorIssuerSecurityTypeReviewRow>;

  tradeForm: FormGroup;

  pageSize: number;
  pageNumber: number;
  pageSizeOptions: number[] = [10, 20, 50];
  pageEvent: PageEvent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  selectedTrades: SenatorIssuerSecurityTypeReviewRow[];
  selectedTradesToProcess: SenatorIssuerSecurityTypeReviewRow[] = [];
  actionToPerform: string;

  issuerSearch: any;
  lastPageNumber: number;

  loadingData: boolean;
  assetNamesLoading: boolean;
  selectedShareType = [] as string[];

  transactionTypes = ['Exchange', 'Purchase', 'Received', 'Sale', 'Sale (Full)', 'Sale (Partial)'];
  amounts: SenatorAmountRanges[];
  assetTypes = SenatorAssetType.values().map(t => t.toString());
  selectedFilterAssetType = '';
  selectedNewMultiAssetType;
  selectedNewSubAssetType;
  selectedNewPrice;
  selectedNewCurrencyCode;
  assetTypeStats = [] as AssetTypeStat[];

  currencyCodes: string[] = [
    'USD',
    'CAD',
    'EUR',
    'AED',
    'AFN',
    'ALL',
    'AMD',
    'ARS',
    'AUD',
    'AZN',
    'BAM',
    'BDT',
    'BGN',
    'BHD',
    'BIF',
    'BND',
    'BOB',
    'BRL',
    'BWP',
    'BYN',
    'BZD',
    'CDF',
    'CHF',
    'CLP',
    'CNY',
    'COP',
    'CRC',
    'CVE',
    'CZK',
    'DJF',
    'DKK',
    'DOP',
    'DZD',
    'EEK',
    'EGP',
    'ERN',
    'ETB',
    'GBP',
    'GEL',
    'GHS',
    'GNF',
    'GTQ',
    'HKD',
    'HNL',
    'HRK',
    'HUF',
    'IDR',
    'ILS',
    'INR',
    'IQD',
    'IRR',
    'ISK',
    'JMD',
    'JOD',
    'JPY',
    'KES',
    'KHR',
    'KMF',
    'KRW',
    'KWD',
    'KZT',
    'LBP',
    'LKR',
    'LTL',
    'LVL',
    'LYD',
    'MAD',
    'MDL',
    'MGA',
    'MKD',
    'MMK',
    'MOP',
    'MUR',
    'MXN',
    'MYR',
    'MZN',
    'NAD',
    'NGN',
    'NIO',
    'NOK',
    'NPR',
    'NZD',
    'OMR',
    'PAB',
    'PEN',
    'PHP',
    'PKR',
    'PLN',
    'PYG',
    'QAR',
    'RON',
    'RSD',
    'RUB',
    'RWF',
    'SAR',
    'SDG',
    'SEK',
    'SGD',
    'SOS',
    'SYP',
    'THB',
    'TND',
    'TOP',
    'TRY',
    'TTD',
    'TWD',
    'TZS',
    'UAH',
    'UGX',
    'UYU',
    'UZS',
    'VEF',
    'VND',
    'XAF',
    'XOF',
    'YER',
    'ZAR',
    'ZMK',
    'ZWL'];

  selection = new SelectionModel<SenatorIssuerSecurityTypeReviewRow>(true, []);

  loading = false;

  constructor(private qualityGateService: SenatorQualityGateService,
              private _senatorService: SenatorService, private senatorService: SenatorService,
              public snackBar: MatSnackBar, private _fb: FormBuilder, private changeDetectorRefs: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.initVars();
    this.createTradeForm();
    this.issuerTableDataSource = new MatTableDataSource<SenatorIssuerSecurityTypeReviewRow>();
    this.getAllSelectedSecurityTypeSpecificIssuerTrades('ABB LTD', 429441 );
  }

  ngAfterViewInit() {
    if (this.issuerTableDataSource) {
      this.issuerTableDataSource.paginator = this.paginator;
      this.issuerTableDataSource.sort = this.sort;
    }
  }

  initVars() {
    this.amounts = SenatorAmountRanges.values();
    this.pageSize = 10;
    this.pageNumber = 1;
    this.lastPageNumber = 0;
  }

  createTradeForm() {
    this.tradeForm = this._fb.group({
      tableRowArray: this._fb.array([])
    });
  }

  initTradeFrom() {
    this.issuerTableDataSource.data.forEach((trade) => {
      this.tradeTableRowArray.push(this.createTradeRow(trade));
    });
  }

  createTradeRow(trade: SenatorIssuerSecurityTypeReviewRow):
    FormGroup {
    return this._fb.group({
      filingId: [trade.filingId],
      trade_id: [trade.trade_id],
      tradeIndex: [trade.tradeIndex || ''],
      transactionDate: [new Date(trade.transactionDate) || '', [Validators.required]],
      filingDate: [new Date(trade.filingDate) || '', [Validators.required]],
      transactionType: [trade.transactionType, Validators.required],
      nameAssigned: [trade.nameAssigned || ''],
      nameBotGrabbed: [trade.nameBotGrabbed || ''],
      x2iqAssetClass: [trade.x2iqAssetClass || '', Validators.required],
      assetSubCategory: [trade.assetSubCategory || '', Validators.required],
      assetType: [(trade.assetType !== null) ? trade.assetType : null, Validators.required],
      noOfShares: [trade.noOfShares || ''],
      price: [trade.price || ''],
      currencyCode: [trade.currencyCode || ''],
      ourComment: [trade.ourComment || ''],
      botComment: [trade.botComment || ''],
      sourceUrl: [trade.sourceUrl],
      type: [trade.type],
      totalCount: [trade.totalCount],
    });
  }

  getAllSelectedSecurityTypeSpecificIssuerTrades(issuerSearch?: string, issuerId?: number) {
   /* this.loadingData = true;

    this.issuerSearch = issuerSearch;


    const filterModel: SenatorIssuerMappingsFilterModel = {
      senatorAssetTypes: SenatorAssetType.values()
        .filter(type => this.selectedShareType.find(t => t == type.toString()) != null),
      qualityGateType: SenatorQualityGateType.ISSUER_TRADE_SECURITY_TYPES,
      processedType: 'ALL',
      assignedName: this.issuerSearch,
      assignedNameId: issuerId
    };

    const params: GetReplaceableAssetNamesParams = {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      issuerMappingsFilterModel: filterModel
    };
    console.log('params: ', params);
    this.loading = true;
    this.qualityGateService.getReplaceableAssetNames(params).subscribe(
      (res: SenatorQualityGateModel) => {

        if (res.objectForIssuerSecurityTypeReview != null && res.objectForIssuerSecurityTypeReview.rowsForAssetTypeStats.length > 0) {
          this.assetTypeStats = res.objectForIssuerSecurityTypeReview.rowsForAssetTypeStats;
        } else {
          this.assetTypeStats = [];
        }

        if (res.objectForIssuerSecurityTypeReview != null && res.objectForIssuerSecurityTypeReview.rowsForIssuerSecurityTypeReview.length > 0) {
          this.issuerTableDataSource = new MatTableDataSource<SenatorIssuerSecurityTypeReviewRow>(res.objectForIssuerSecurityTypeReview.rowsForIssuerSecurityTypeReview);
          this.applyAssetTypeFilter();
        } else {
          this.issuerTableDataSource = new MatTableDataSource<SenatorIssuerSecurityTypeReviewRow>();
        }
      },
      error => {
        this.loadingData = false;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.loadingData = false;
        this.issuerTableDataSource.paginator = this.paginator;
        this.createTradeForm();
        this.initTradeFrom();
      }
    );*/
  }

  openSnackBar(message: string, action: string
  ) {
    this.snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  onPaginateChange(event: PageEvent) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    // this.getAllSelectedSecurityTypeSpecificIssuerTrades();
    // console.log('onPaginateChange: event', event);
  }

  openTrade(trade_id: number, type: string) {
    this.showTradeById.loadDialog(trade_id, type == 'R' ? 'Representative' : 'Senator');
  }

  tradeClosedEvent() {
    this.getAllSelectedSecurityTypeSpecificIssuerTrades();
  }

  searchAssetNames(companyName: string) {
    // this.activeRow = trade;
    this.assetNamesLoading = true;
    // console.log('Key up event', name);
    this._senatorService.getSenatorAssetNames(companyName).subscribe((res: SenatorCompany[]) => {
      this.twoIQAssetsList = res;
    }, (err) => {
      this.assetNamesLoading = false;
      // console.log('file update Error', err);
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong! please enter a valid company name.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {
      this.assetNamesLoading = false;
      if (this.twoIQAssetsList.length === 0) {

        this.snackBar.open('No Company found with this name', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }
    });
  }

  applyAssetTypeFilter() {
    console.log('filter selection: ', this.selectedFilterAssetType);
    this.applyFilter(this.selectedFilterAssetType);
    this.selection.clear();
  }

  onSaveClick(option: string, row: SenatorIssuerSecurityTypeReviewRow) {

    console.log('row: ', row);

    this.selectedTradesToProcess = [];

    switch (option) {
      case 'single' :
        this.selectedTrades = [row];
        break;

      case 'multiple':
        this.selectedTrades = this.selection.selected;
        break;
    }

    this.selectedTradesToProcess = this.tradeTableRowArray.controls
      .filter(
        trade => this.selectedTrades.find(indexing => indexing.trade_id == trade.value.trade_id) != null
      ).map(t => {
        return t.value as SenatorIssuerSecurityTypeReviewRow;
      });


    console.log('this.tradeTableRowArray: ', this.tradeTableRowArray);
    console.log('this.selectedTrades: ', this.selectedTrades);
    console.log('this.selectedTradesToProcess: ', this.selectedTradesToProcess);
    this.saveTrades();
  }


  saveTrades() {
    console.log('selections ', this.selection);
    console.log('status', this.selection.selected.length == 0);

    const newAssetType = this.selectedNewMultiAssetType;
    console.log('new asset type: ', newAssetType);
    const newSubAssetType = this.selectedNewSubAssetType;
    console.log('new sub asset type: ', newSubAssetType);
    const newPrice = this.selectedNewPrice;
    console.log('new price: ', newPrice);
    const newCurrencyCode = this.selectedNewCurrencyCode;
    console.log('new country currency: ', newCurrencyCode);

    const params: SenatorIssuerSecurityTypeUpdate = {
      senatorIssuerSecurityTypeReviewRow: this.selectedTradesToProcess,
      assetType: newAssetType,
      assetSubCategory: newSubAssetType,
      price: newPrice,
      currencyCode: newCurrencyCode
    };
    console.log('params: ', params);

    this.qualityGateService.updateAllIssuerSecurityTypeReviewRow(params).subscribe((res: any) => {
      console.log('save multiple res', res);
      this.clearSelections();
      this.openSnackBar('Record details has been updated successfully!', 'Close');
      this.getAllSelectedSecurityTypeSpecificIssuerTrades(this.issuerSearch);

    }, (err) => {
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong!.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();

    this.issuerTableDataSource.filterPredicate = function (data: SenatorIssuerSecurityTypeReviewRow, filterValue: string) {
      return data.assetType
        .trim()
        .toLocaleLowerCase() === filterValue;
    };

    this.issuerTableDataSource.filter = filterValue;
  }


  replaceAtMultipleRows(value, action: string
  ) {
    // console.log('Replace multiple rows:', value, action)
    let selectedFiled;
    switch (action) {

      case 'price':
        selectedFiled = 'price';
        break;
      case 'currencyCode':
        selectedFiled = 'currencyCode';
        break;
      case 'noOfShares':
        selectedFiled = 'noOfShares';
        break;
    }
    this.selection.selected.forEach(trade => {
      // tslint:disable-next-line:no-shadowed-variable
      const trade_id = this.tradeTableRowArray.value.map(value => value.trade_id).indexOf(trade.trade_id);
      this.tradeTableRowArray.at(trade_id).get(selectedFiled).setValue(value);


      // console.log(this.tradeTableRowArray);
    });
    this.table.renderRows();
    // this.validateSelectedForm();

  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.issuerTableDataSource.filteredData.forEach(row => this.selection.select(row));
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.issuerTableDataSource.filteredData.length;
    return numSelected === numRows;
  }


  clearSelections() {
    this.selection.clear();
    this.selectedNewMultiAssetType = undefined;
    this.selectedNewSubAssetType = undefined;
    this.selectedNewPrice = undefined;
    this.selectedNewCurrencyCode = undefined;
  }

  isRowSelected(row: SenatorIssuerSecurityTypeReviewRow) {
    return this.selection.selected.find(element => element.trade_id === row.trade_id);
  }

  _getFormArrayItemControl(i: number, controlName: string): FormControl {
    const group = (<FormGroup>(<FormArray>this.tradeForm.get('tableRowArray')).controls[i]);
    return (<FormControl>(group.controls[controlName]));
  }


  getActualIndex(index: number) {
    return index + this.paginator.pageSize * this.paginator.pageIndex;
  }

  get tradeTableRowArray(): FormArray {
    return this.tradeForm.get('tableRowArray') as FormArray;
  }

}
